import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { LIVE_MANAGE_PATH } from '@constant'
import { hashHistory, Link } from 'react-router'
import { isImageMogr2 } from '@util'
import { observer } from 'mobx-react'
import { Button } from 'hljd'
import Store from './store'
import Style from './style.module.less'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.init()
  }

  goLiveManage = () => {
    hashHistory.push(`${LIVE_MANAGE_PATH}`)
  }

  getList = list => {
    let _list = [...list]
    let len = 6 - _list.length
    while (len > 0 && len != 6) {
      _list.push({})
      len--
    }
    return _list
  }

  render() {
    const header = [<Link to={LIVE_MANAGE_PATH}>视频直播</Link>, '直播帮助']
    const { guide_list, poster, goPoster, goArtical } = this.store
    // const list = this.getList(guide_list)
    //console.log(list)
    return (
      <HeaderView title="直播帮助" header={header}>
        <div>
          <div className={Style.title}>常见直播问题</div>
          <div className={Style.guide}>
            {/* <div className={Style.artical} onClick={this.goArtical}>
              <img src={15744334433}/>
              <div className={Style['sub-title']}>如何进行直播？</div>
            </div>
            <div className={Style.artical} onClick={this.goArtical}>
              <img />
              <div className={Style['sub-title']}>如何提高直播曝光？</div>
            </div>
            <div className={Style.artical} onClick={this.goArtical}>
              <img />
              <div className={Style['sub-title']}>如何提高直播联系转化？</div>
            </div> */}
            {guide_list.map((item, index) => (
              <div
                className={Style.artical}
                onClick={goArtical(item.id, item._href)}
                key={index}
              >
                {item.list_img ? (
                  <div className={Style['img-wrapper']}>
                    <img src={isImageMogr2(item.list_img, 260, 146)} />
                  </div>
                ) : (
                  <div style={{ height: 146, width: 260 }} />
                )}

                <div className={Style['sub-title']}>{item.title}</div>
              </div>
            ))}
          </div>
          {poster ? (
            <div className={Style.poster} onClick={goPoster}>
              <img
                src={`${poster.image_path}?imageView2/2/w/1900`}
                width={940}
              />
            </div>
          ) : (
            ''
          )}
          <div style={{ textAlign: 'center', marginTop: 38 }}>
            <Button type="primary" onClick={this.goLiveManage}>
              返回视频直播
            </Button>
          </div>
        </div>
      </HeaderView>
    )
  }
}
